export const environment = {
    name: 'server',
    production: false,
    baseUrl: '', 
    venueUrl: 'https://prembid-venueapi-dot-prembid.ew.r.appspot.com',
    lotsUrl: 'https://prembid-lotapi-dot-prembid.ew.r.appspot.com'
};